import axios from 'apis/axios';
import {makeUseAxios} from 'axios-hooks';

export const useAxios = makeUseAxios({
    axios
});